import OpenAI from "openai";
let API_KEY = '';
//API_KEY = process.env.VUE_APP_OPENAI_API_KEY

//const openai = new OpenAI({ apiKey: API_KEY, dangerouslyAllowBrowser: true });



export async function sugerirSubtopicos(input) {
   const response = await openai.chat.completions.create({
       model: "gpt-3.5-turbo",
       response_format: { type: "json_object" },
       messages: [
           {
               "role": "system",
               "content": [
                   {
                       "type": "text",
                       "text": "Você ajuda professores a identificar conceitos que são necessários explorar ao ensinar sobre um tópico mais abrangente para que os estudantes consigam dominar o conteúdo. Ao receber um tópico, você retorna um array JSON, com a chave conceitos, com até 5 conceitos. Em alguns casos pode ser menos para evitar conceitos irrelevantes."
                   }
               ]
           },
           {
               "role": "user",
               "content": [
                   {
                       "type": "text",
                       "text": input
                   }
               ]
           }
       ],
       temperature: 0.97,
       max_tokens: 256,
       top_p: 1,
       frequency_penalty: 0,
       presence_penalty: 0,
   });

   console.log(response.choices[0].message.content);

    return response.choices[0].message.content;
    
    
}



export async function criarQuestoesIA(user, system){
   
    const response = await openai.chat.completions.create({
        model: "gpt-4o",
        response_format: { type: "json_object" },
        messages: [
            {
                "role": "system",
                "content": [
                    {
                        "type": "text",
                        "text": system
                    }
                ]
            },
            {
                "role": "user",
                "content": [
                    {
                        "type": "text",
                        "text": user
                    }
                ]
            }
        ],
        temperature: 1,
        max_tokens: 3429,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
    });
   console.log(response);
   const content = response.choices[0].message.content;
   const usage = response.usage;
    return {content, usage};

}

function isValidJSON(text) {
    try {
        JSON.parse(text);
        return true;
    } catch (error) {
        return false;
    }
}